import { WpPayment } from './wp-payment.model';

export class PaymentDetailsVo {
  constructor(
    public paymentId?: number,
    public wpPayment?: WpPayment,

  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/payment-details.model.ts